export default __webpack_public_path__ + "static/media/discord-v2.61d53db1.svg";